import type { NamespacedExtract } from '@cli-types/next-adapter/snapshots.js'
import { renderDbBarrelContentTemplate } from '@next-adapter/templates/renderers/snapshots/barrels/render-db-barrel.js'

export function renderDbBarrel(dbExtracts: NamespacedExtract[]): string {
  const exportLines = dbExtracts.map(
    (extract) => `export * from './${extract.namespace}/${extract.name}'`
  )
  return renderDbBarrelContentTemplate({
    exportLinesContent: String(exportLines.length > 0 ? `\n${exportLines.join('\n')}\n` : '\n')
  })
}
